module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAGCAYAAADZq14TAAAAAXNSR0IArs4c6QAAAJxJREFUKFOt0CEOAjEQQNE/CoXDcA/ErofWoRsM3IArcAQsCkvYBE036F3MXoEToFAkmzCkhBIMAkr9/DdTIfHtM7sWYQYUde3dAm7vSUnsU+Z2rrAMHYHtqPZOQGM3GQghn5kpIiugg+rGHMtJRB6Az00B8lK/vUrgqjAE+mFWlV2vPbtB07RPwP4c/7iMcujKZRyB6v9C+BM53QHIQS0loEGMTgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/transport.png
// module id = f+g/
// module chunks = 36